<template>
  <video   id="videoHolder"  @ended="playNext()" autoplay  ref="player" width="100%"  controls controlsList="nodownload">
      <source  ref="source" :src="mediaPath" type="video/mp4">
  </video>
</template>

<script>
import axios from 'axios'
export default {
  name: 'videoPlayer',
  props: ['path'],
  data () {
    return {
      mediaPath: this.path,
      lang: 'en',
      media: '',
      videoHolder: '',
      currentTime: 0,
      previousCalled: 0
    }
  },
  mounted () {
    this.videoHolder = document.getElementById('videoHolder')
    // set video time by fetchingprevious time
    if (this.$store.getters.getIsplaylist) {
      if (this.$store.getters.getcurrentPlaylist !== null && this.$store.getters.getcurrentPlaylist.length > 0) {
        // this.videoHolder.currentTime = this.$store.getters.getEnrolledLODataByContentIdProfileId.lastViewedDuration
      } else {
        // this.videoHolder.currentTime = this.$store.getters.getEnrolledLODataByContentIdProfileId.lastViewedDuration
      }
    } else {
      // this.videoHolder.currentTime = this.$store.getters.getEnrolledLODataByContentIdProfileId.lastViewedDuration
    }
  },
  methods: {
    playNext: function (event) {
      this.$store.dispatch('setLoaderStatus', true)
      if (this.$store.getters.getCurrentContentViewerPlaylist !== null) {
        for (var i = 0; i < this.$store.getters.getCurrentContentViewerPlaylist.length; i++) {
          if (this.$store.getters.getCurrentContentViewerPlaylist[i].contentId === this.$store.getters.getcurrentPlayingContent.contentId) {
            if ((this.$store.getters.getCurrentContentViewerPlaylist.length - 1) > (i)) {
              return new Promise((resolve, reject) => {
                setTimeout(() => {
                  this.$store.dispatch('setCurrentPlayingContent', this.$store.getters.getCurrentContentViewerPlaylist[i + 1]).then(response => {
                    this.$store.dispatch('setLoaderStatus', false)
                    axios.post('r/contentviewer/updatelowatchcount', {'profileId': this.$store.getters.getProfileDetails.profileId, 'itemId': this.$store.getters.getcurrentPlaylist.lastItemViewed.itemId}).then(response => {
                      this.$store.dispatch('fetchEnrolledItems', this.$store.getters.getProfileDetails.profileId)
                    }).catch(err => {
                      console.log(err)
                    })
                    resolve(i)
                  })
                }, 1000)
              })
            } else {
              this.$store.dispatch('setLoaderStatus', false)
              break
            }
          }
        }
      }
    }
  },
  watch: {
    path: function (newValue, oldValue) {
      /* axios.post('r/contentviewer/updatedurationbycountno', { 'profileId': this.$store.getters.getProfileDetails.profileId, 'playListId': this.$store.getters.getcurrentPlaylist.plId, 'itemId': this.$store.getters.getPreviousContent.contentId, 'lastViewedDuration': parseInt(this.$refs.player.currentTime) })
      this.$store.dispatch('fetchEnrolledItems', this.$store.getters.getProfileDetails.profileId)
      .then(response => {
      })
      .catch(err => {
        console.log(err)
      }) */
      this.mediaPath = newValue
      if (this.$store.getters.getIsplaylist) {
        // this.$store.dispatch('updatePlaylistItemDuration', {'profileId': this.$store.getters.getProfileDetails.profileId, 'itemId': this.$store.getters.getcurrentPlayingContent.contentId, 'lastDuration': this.$refs.player.currentTime}).then(response => {
        /* return new Promise((resolve, reject) => {
          axios.post('r/contentviewer/updatedurationbycountno', { 'profileId': this.$store.getters.getProfileDetails.profileId, 'itemId': this.$store.getters.getPreviousContent.contentId, 'lastViewedDuration': parseInt(this.$refs.player.currentTime), 'plId': this.$store.getters.getcurrentPlaylist.plId })
          .then(response => {
            this.$store.dispatch('fetchEnrolledItems', this.$store.getters.getProfileDetails.profileId)
            resolve()
          })
          .catch(err => {
            console.log(err)
            reject()
          })
        }) */
        // })
      } else {
        /* return new Promise((resolve, reject) => {
          axios.post('r/contentviewer/updatedurationbycountno', { 'profileId': this.$store.getters.getProfileDetails.profileId, 'itemId': this.$store.getters.getPreviousContent.contentId, 'lastViewedDuration': parseInt(this.$refs.player.currentTime) })
          .then(response => {
            this.$store.dispatch('fetchEnrolledItems', this.$store.getters.getProfileDetails.profileId)
            this.videoHolder = document.getElementById('videoHolder')
            var innerHTMLObj = '<source ref="source" src="' + newValue + '" type="video/mp4">'
            this.videoHolder.innerHTML = ''
            this.videoHolder.innerHTML = innerHTMLObj
            this.previousCalled = 0
            // this.$refs.player.currentTime = this.$store.getters.getEnrolledLODataByContentIdProfileId.lastViewedDuration
            this.$refs.player.load()
            resolve()
          })
          .catch(err => {
            console.log(err)
            reject()
          })
        }) */
        // this.videoHolder = document.getElementById('videoHolder')
        // var innerHTMLObj = '<source ref="source" src="' + newValue + '" type="video/mp4">'
        // this.videoHolder.innerHTML = ''
        // this.videoHolder.innerHTML = innerHTMLObj
        // this.previousCalled = 0
        // // this.$refs.player.currentTime = this.$store.getters.getEnrolledLODataByContentIdProfileId.lastViewedDuration
        // this.$refs.player.load()
      }
      // console.log('video:newpath:' + newValue + 'oldapth:' + oldValue)
      this.videoHolder = document.getElementById('videoHolder')
      var innerHTMLObj = '<source ref="source" src="' + newValue + '" type="video/mp4">'
      this.videoHolder.innerHTML = ''
      this.videoHolder.innerHTML = innerHTMLObj
      this.previousCalled = 0
      // this.$refs.player.currentTime = this.$store.getters.getEnrolledLODataByContentIdProfileId.lastViewedDuration
      this.$refs.player.load()
    }
  },
  beforeDestroy () {
    if (this.$store.getters.getIsPurchase(this.$store.getters.getcurrentPlayingContent.contentId)) {
      if (this.$store.getters.getIsplaylist) {
        this.$store.dispatch('updatePlayListLastItemViewedByPlaylistId', {'plId': this.$store.getters.getcurrentPlaylist.plId, 'itemId': this.$store.getters.getcurrentPlayingContent.contentId, 'lastViewedDuration': this.$refs.player.currentTime})
        /* return new Promise((resolve, reject) => {
          axios.post('r/contentviewer/updatedurationbycountno', { 'profileId': this.$store.getters.getProfileDetails.profileId, 'playListId': this.$store.getters.getcurrentPlaylist.plId, 'itemId': this.$store.getters.getcurrentPlayingContent.contentId, 'lastViewedDuration': parseInt(this.$refs.player.currentTime) })
          .then(response => {
            this.$store.dispatch('fetchEnrolledItems', this.$store.getters.getProfileDetails.profileId)
            resolve()
          })
          .catch(err => {
            console.log(err)
            reject()
          })
        }) */
      } else {
        /* return new Promise((resolve, reject) => {
          axios.post('r/contentviewer/updatedurationbycountno', { 'profileId': this.$store.getters.getProfileDetails.profileId, 'itemId': this.$store.getters.getcurrentPlayingContent.contentId, 'lastViewedDuration': parseInt(this.$refs.player.currentTime) })
          .then(response => {
            this.$store.dispatch('fetchEnrolledItems', this.$store.getters.getProfileDetails.profileId)
            resolve()
          })
          .catch(err => {
            console.log(err)
            reject()
          })
        }) */
      }
    }
    this.previousCalled = 0
    this.$refs.player.pause()
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/contentViewer/contentHelper/videoPlayer.vue?b509afe8